import useCookie from "react-use-cookie";
import { parseStatsCookie,  STATS_COOKIE_NAME } from "../cookies";
import { winPercentage, bestStreak, currentStreak, breakdown } from "../stats";
import "./StatsVisualizer.css";

type StatsVisualizerProps = {
  suffix: string;
  mostRecentGameNumber: number;
}

export const StatsVisualiser: React.FC<StatsVisualizerProps> = ({mostRecentGameNumber, suffix}: StatsVisualizerProps) => {
  const [statsCookie] = useCookie(STATS_COOKIE_NAME);
  const stats = parseStatsCookie(statsCookie);

  const breakdownData = breakdown(stats);
  return (
  <section className="StatsViz">
    <h4>Statistics</h4>
    <hr />
    <div className="StatsBox">
      <dl><dt><h2>{stats.length}</h2></dt><dd><p>Played</p></dd></dl>
      <dl><dt><h2>{winPercentage(stats)}</h2></dt><dd><p>Win%</p></dd></dl>
      <dl><dt><h2>{bestStreak(stats, mostRecentGameNumber)}</h2></dt><dd><p>Best streak</p></dd></dl>
      <dl><dt><h2>{currentStreak(stats, mostRecentGameNumber)}</h2></dt><dd><p>Current streak</p></dd></dl>
    </div>
    <hr />
    <div className="StatsChart">
      {breakdownData.categories.map( breakdownCat =>
        <div className="ChartRow" key={`${breakdownCat.label}${suffix}`}>
          <h4>{breakdownCat.label}</h4>  
          <div className="RowBG">
            <div className="tube" style={{width: `${breakdownCat.frequency * 100 / breakdownData.maxFrequency}%`}}>
              <p>{breakdownCat.frequency > 0 && breakdownCat.frequency}</p>
            </div>
          </div>
        </div>
      )}
    </div>
    <hr />
  </section>
  )
}